module.exports = __webpack_public_path__ + "static/media/screen-server-dashboard.16ebe92f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/WorksSection/screens/screen-server-dashboard.png
// module id = 329
// module chunks = 0